// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"408a4aa2","74":"b4bbfee1","107":"5bede9fa","213":"890fae63","250":"7a22eac8","331":"06ef1f43","389":"16fbdf1c","976":"6e427011"}[chunkId] + ".chunk.js";
};